import React from 'react';
import { SortOption, SegmentOption } from '../../hooks/useDashboardFilters';

interface DashboardFiltersProps {
  selectedSegment: SegmentOption;
  sortBy: SortOption;
  onSegmentChange: (segment: SegmentOption) => void;
  onSortChange: (sort: SortOption) => void;
}

const DashboardFilters: React.FC<DashboardFiltersProps> = React.memo(({
  selectedSegment,
  sortBy,
  onSegmentChange,
  onSortChange,
}) => {
  return (
    <div className="filters" role="region" aria-label="Dashboard Filters">
      <div className="filter-group">
        <label htmlFor="segment-filter">Segment:</label>
        <select 
          id="segment-filter"
          value={selectedSegment} 
          onChange={(e) => onSegmentChange(e.target.value as SegmentOption)}
          aria-label="Filter customers by segment"
        >
          <option value="all">All Segments</option>
          <option value="small_business">Small Business</option>
          <option value="enterprise">Enterprise</option>
          <option value="e-commerce">E-commerce</option>
        </select>
      </div>
      <div className="filter-group">
        <label htmlFor="sort-filter">Sort by:</label>
        <select 
          id="sort-filter"
          value={sortBy} 
          onChange={(e) => onSortChange(e.target.value as SortOption)}
          aria-label="Sort customers by metric"
        >
          <option value="progress">Progress</option>
          <option value="health">Health Score</option>
          <option value="days">Days in Onboarding</option>
        </select>
      </div>
    </div>
  );
});

DashboardFilters.displayName = 'DashboardFilters';

export default DashboardFilters;